// extracted by mini-css-extract-plugin
module.exports = {"phoneWarn":"otp-confirmation_phoneWarn__C7htO","inputContainer":"otp-confirmation_inputContainer__W0LE4","phoneInput":"otp-confirmation_phoneInput__XUPzQ"};